import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAuthService } from '../services/api';

export const useAuthAdmin = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    // Check if admin is authenticated
    const authStatus = localStorage.getItem('authenticated');
    const token = localStorage.getItem('token');

    if (authStatus === 'true' && token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      // Only navigate if we're not already on the login page
      if (window.location.pathname !== '/login') {
        navigate('/login');
      }
    }
    setIsCheckingAuth(false);
  }, [navigate]); // Include navigate in dependencies

  const handleLogout = async () => {
    try {
      await adminAuthService.logout();
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      localStorage.removeItem('authenticated');
      localStorage.removeItem('token');
      navigate('/login');
    }
  };

  return {
    isAuthenticated,
    isCheckingAuth,
    handleLogout,
  };
};
